var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"left"},[_c('section',[_c('h3',[_vm._v(_vm._s(_vm.timeSign)+"，"+_vm._s(_vm.username)+"！")]),_c('p',[_vm._v("欢迎使用由英海瑞特科技研发系统，祝您工作愉快~")])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }